import React from "react";
import ParticleBackground from "../../../ParticleBackground/ParticleBackground";
import Header from "../../../Shared/Header";
import AboutMe from "../AboutMe/AboutMe";
import Banner from "../Banner/Banner";
import MyContact from "../MyContact/MyContact";
import MyProjects from "../MyProjects/MyProjects";
import "./Home.css";

const Home = () => {
   return (
      <div>
         
         
         <Banner></Banner>
         
         <AboutMe></AboutMe>
         <MyProjects></MyProjects>
         <MyContact></MyContact>
      </div>
   );
};

export default Home;
